var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.92,
    height: 28.96,
    viewBox: "0 0 50.92 28.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f58634;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.2.48A11.789,11.789,0,0,1,7.56-1.34,11.854,11.854,0,0,1,3.3-6.42,17.968,17.968,0,0,1,1.8-14a18,18,0,0,1,1.5-7.56,11.834,11.834,0,0,1,4.26-5.1,11.79,11.79,0,0,1,6.64-1.82,11.789,11.789,0,0,1,6.64,1.82,11.834,11.834,0,0,1,4.26,5.1A18,18,0,0,1,26.6-14a17.968,17.968,0,0,1-1.5,7.58,11.854,11.854,0,0,1-4.26,5.08A11.789,11.789,0,0,1,14.2.48Zm0-4.6a6.194,6.194,0,0,0,5.16-2.64,11.732,11.732,0,0,0,2-7.24,11.732,11.732,0,0,0-2-7.24,6.194,6.194,0,0,0-5.16-2.64,6.178,6.178,0,0,0-5.18,2.64A11.819,11.819,0,0,0,7.04-14,11.819,11.819,0,0,0,9.02-6.76,6.178,6.178,0,0,0,14.2-4.12ZM43.92,0V-5.2H30.12V-9.28L43.24-28h5.8V-9.64h3.68V-5.2H49.04V0ZM35.6-9.64h8.64V-22.36Z",
    transform: "translate(-1.8 28.48)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.37593b3f6d22bd8d73ff1a8cdca8728b.svg";
export { ForwardRef as ReactComponent };